module.exports = __webpack_public_path__ + "static/media/loader-security.1e2b4c65.gif";